import { projectContract } from './project.contract';
import { areaContract } from './area.contract';
import { floorContract } from './floor.contract';
import { certificateContract } from './certificate.contract';
import { utilityContract } from './utility.contract';
import { professionContract } from './profession.contract';
import { organizationContract } from './organization.contract';
import { managerContract } from './manager.contract';

// Individual re-exports (for route files importing specific contracts)
export { projectContract } from './project.contract';
export { areaContract } from './area.contract';
export { floorContract } from './floor.contract';
export { certificateContract } from './certificate.contract';
export { utilityContract } from './utility.contract';
export { professionContract } from './profession.contract';
export { organizationContract } from './organization.contract';
export { managerContract } from './manager.contract';

// Aggregated export for service client creation
export const projectConfigContracts = {
	projectContract,
	areaContract,
	floorContract,
	certificateContract,
	utilityContract,
	professionContract,
	organizationContract,
	managerContract,
};
